import { Box } from '@mantine/core';
import { UsersTable } from './users/components/UsersTable';
import { AdminTabs, useAdminTabs } from './hooks/useAdminTabs';
import { useMemo } from 'react';
import UnderlineTabsDeprecated from 'src/UI/page-nav/UnderlineTabsDeprecated';
import DataExportConfigPage from 'src/company/data-export-config/DataExportConfigPage';
import ManageSiestaSkillsPage from './manage-siesta-skills/ManageSiestaSkillsPage';
import DevToolsPage from './dev-tools/DevToolsPage';
import { useFlags } from 'src/feature-flags/FlagsHook';

export default function AdminPage() {
  const { currentTab, setTab } = useAdminTabs();
  const { flagEnabledDevTools } = useFlags();

  const tabContent = useMemo(() => {
    if (currentTab === AdminTabs.Users) {
      return <UsersTable />;
    }

    if (currentTab === AdminTabs.Appearance) {
      return <Box>Appearance settings will be here.</Box>;
    }
  }, [currentTab]);

  if (currentTab === AdminTabs.DataExportConfig) {
    return (
      <Box p="md">
        <DataExportConfigPage />
      </Box>
    );
  }

  if (currentTab === AdminTabs.ManageSiestaSkills) {
    return (
      <Box p="md">
        <ManageSiestaSkillsPage />
      </Box>
    );
  }

  if (currentTab === AdminTabs.DevTools && flagEnabledDevTools) {
    return <DevToolsPage />;
  }

  return (
    <Box p="md">
      <UnderlineTabsDeprecated
        value={currentTab}
        onChange={value => {
          if (value != null) {
            setTab(value as AdminTabs);
          }
        }}
      >
        <UnderlineTabsDeprecated.List>
          <UnderlineTabsDeprecated.Tab value={AdminTabs.Users}>Users</UnderlineTabsDeprecated.Tab>
        </UnderlineTabsDeprecated.List>

        <Box mt="sm">{tabContent}</Box>
      </UnderlineTabsDeprecated>
    </Box>
  );
}
